import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import ErrorPageComponent from './ErrorPageComponent'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch, { router }) => ({
  handleRouteToLogin () {
    router.push({
      pathname: '/',
    })
  },
})

const ErrorPage = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ErrorPageComponent)
)

export default ErrorPage



// WEBPACK FOOTER //
// ./src/gallery/components/ErrorPage.js